import {Component, Inject, Injector, OnInit, PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {BaseComponent} from '../@shared/base.component';
import {ActivatedRoute, Router} from '@angular/router';
import {PreviousRouteService} from '../@shared/previous-route.service';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html'
})
export class RedirectComponent extends BaseComponent implements OnInit {

    public override debug: boolean = false;

    constructor(@Inject(DOCUMENT) public document: Document,
                @Inject(PLATFORM_ID) public platformId: any,
                private previousRouteService: PreviousRouteService,
                public override route: ActivatedRoute,
                public override router: Router,
                public override injector: Injector) {
        super(route, router, injector);
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const prev: string = this.previousRouteService.getPrevious();
            this.inspect(prev);
        }
    }

    inspect(route: string): void {
        if ('/' === route) {
            this.router.navigateByUrl('/home');
        } else {
            if (route && route.length > 0) {
                let prevCtx: string = route.substring(0, route.lastIndexOf('/'));

                if (this.urls.indexOf(prevCtx) === -1) {
                    this.log('Url path [' + prevCtx + '] not configured under Router. Redirecting to [/redirect].')
                    this.inspect(prevCtx);
                } else {
                    let routerUrl: string = this.urls[this.urls.indexOf(prevCtx)];
                    this.log('Url path [' + prevCtx + '] matched [' + prevCtx + '] under Router. Continuing.');
                    this.log('Urls configured under Router: [' + super.getUrls() + ']');

                    this.router.navigateByUrl(routerUrl);
                }
            } else {
                this.router.navigateByUrl('/home');
            }
        }
    }
}
